import React from 'react';

import {
  FormLabel,
  FormInputHolder,
  FormInput,
  FormRadio,
} from '../../form';

import {
  composeValidators,
  maxLength,
  valueIsNumber
} from '../../../helpers/formValidators';
import Duration from '../Duration';

export default () => {
  return (
    <div>
      <FormLabel for="breastPumped" note="Optional">Select Breast Pumped</FormLabel>
      <div className="form-radio__group">
        <FormRadio
          key='breastPumped.both'
          name="breastPumped"
          value='both'
          box
        >
          Both
        </FormRadio>

        <FormRadio
          key='breastPumped.left'
          name="breastPumped"
          value='left'
          box
        >
          Left
        </FormRadio>

        <FormRadio
          key='breastPumped.right'
          name="breastPumped"
          value='right'
          box
        >
          Right
        </FormRadio>
      </div>

      <FormInputHolder>
        <FormInput
          name="breastPumpedAmount"
          labelRenderer={() => (<FormLabel for="amount" note="Optional">Amount</FormLabel>)}
          measurement={'ml'}
          initialValue='100.0'
          type="number"
          validate={composeValidators(maxLength(100), valueIsNumber)}
        />
      </FormInputHolder>

      <Duration />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/FieldExcerpts/Pumping.js